var map = {
	"./news.de-CH.json": 1441,
	"./news.de-DE.json": 1442,
	"./news.en-CA.json": 1443,
	"./news.en-GB.json": 1444,
	"./news.en-IN.json": 1445,
	"./news.en-ME.json": 1446,
	"./news.en-US.json": 1447,
	"./news.es-EM.json": 1448,
	"./news.es-ES.json": 1449,
	"./news.fr-BE.json": 1450,
	"./news.fr-CA.json": 1451,
	"./news.fr-CH.json": 1452,
	"./news.nl-BE.json": 1453,
	"./news.nl-NL.json": 1454,
	"./news.pl-PL.json": 1455,
	"./news.pt-BR.json": 1456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1440;